import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { isMyJobsOnlyAtom } from './filterAtom';
import { STATUS_LABELS } from './statusLabels';

// This hook only shares the status configuration data
export const useStatusConfig = () => {
  const isMyJobsOnly = useAtomValue(isMyJobsOnlyAtom);

  const statusConfig = useMemo(
    () => [
      { label: isMyJobsOnly ? 'My' : 'All', status: 'ANY' },
      ...Object.entries(STATUS_LABELS).map(([status, label]) => ({
        label,
        status,
      })),
    ],
    [isMyJobsOnly]
  );

  return { statusConfig };
};

